module.exports = __webpack_public_path__ + "img/debt.9048c820.png";